import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Finance.AccountReceivable.Find.IRequest;
type Response = Api.Finance.AccountReceivable.Find.IResponse;
type Headers = Api.Finance.AccountReceivable.Find.IHeaders;
const url = '/api/Finance/AccountReceivable/:id';
export default async function accountReceivableFindApi(params: { id: number }): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url: createPathFromRoute(url, params),
    headers: getDefaultHeaders(),
  });
}
